import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  configuratorActions,
  selectCalledOnce,
  selectCanInitUnityScene,
  selectScenesLoaded,
  selectSelectedSceneId,
  selectUnityBaseSceneReady,
  selectUnityLoaded,
  selectUnitySceneLoaded,
} from '../../../redux/slicers/configurator/configurator.slicer';
import { initUnity } from '../unity/initUnity';
import { useInitialObjectProperties } from '../hooks/useInitialObjectProperties';
import { dispatcher } from '../../../helpers/projectHelper';
import { getAppState } from '../../../redux/store';

export const init = async (sceneId) => {
  const callOnlyOnce = selectCalledOnce(getAppState());
  const unitySceneLoaded = selectUnitySceneLoaded(getAppState());
  const isLoaded = !callOnlyOnce ? !unitySceneLoaded : unitySceneLoaded;
  if (!isLoaded) {
    return;
  }
  dispatcher(configuratorActions.setIsUnityInitializing(true));
  await initUnity({ sceneId });
  dispatcher(configuratorActions.setCalledOnce(true));
  dispatcher(configuratorActions.setIsUnityInitializing(false));
};

export const useInitConfigurator = () => {
  const dispatch = useDispatch();
  const unityLoaded = useSelector(selectUnityLoaded);
  const sceneId = useSelector(selectSelectedSceneId);
  const scenesLoaded = useSelector(selectScenesLoaded);
  const canInitUnityScene = useSelector(selectCanInitUnityScene);
  const unityBaseSceneReady = useSelector(selectUnityBaseSceneReady);

  useInitialObjectProperties();

  useEffect(() => {
    dispatch(configuratorActions.setCalledOnce(false));
    return () => {
      dispatch(configuratorActions.setCalledOnce(false));
    };
  }, []);

  useEffect(() => {
    if (unityLoaded && scenesLoaded && canInitUnityScene && unityBaseSceneReady) {
      init(sceneId);
    }
  }, [unityLoaded, sceneId, scenesLoaded, canInitUnityScene, unityBaseSceneReady]);
};
